/* src/app/components/core/layout/inner-page-layout/inner-page-layout.component.css */
/*# sourceMappingURL=inner-page-layout.component-MNEM2SWI.css.map */
